export type BoolEnum = 'True' | 'False';

export const BoolEnum = {
    True: 'True' as BoolEnum,
    False: 'False' as BoolEnum
};